import { isChannelCompatibleWithParent } from "src/pages/decision-engines/channel-parent-model";
import type { Channel, Message } from "src/pages/decision-engines";
import { isJourneyChannel } from "src/pages/decision-engines/flows/flow-utils";

export function isActiveChannel(channel: Pick<Channel, "enabled">): boolean {
  return channel.enabled;
}

export function isActiveMessage(
  message: Pick<Message, "deleted_at"> & { channel: Pick<Channel, "enabled"> },
): boolean {
  return !message.deleted_at && isActiveChannel(message.channel);
}

export function isActiveFlowMessage(row: {
  message: Parameters<typeof isActiveMessage>[0];
}): boolean {
  return isActiveMessage(row.message);
}

export function getSelectableMessageChannels<
  T extends Pick<Channel, "enabled" | "type" | "parent_model_id">,
>(channels: T[], onsite: boolean, parentModelId: string): T[] {
  return channels.filter(
    (channel) =>
      isActiveChannel(channel) &&
      !isJourneyChannel(channel) &&
      (!onsite || channel.type === "surface") &&
      isChannelCompatibleWithParent(channel, parentModelId),
  );
}
